export default "__VITE_ASSET__DEoapC1T__"